<template>
  <div class="c-chart">
    <div class="chart-dom-container" ref="container">
      <div ref="chart" class="chart-dom"></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'KnowledgeChart',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    edges: {
      type: Array,
      default: () => [],
    },
    course: {
      type: Object,
      default: () => ({}),
    },
    subjectId: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      visibleLo: false,
      currentCode: '',
      legend: [{
        name: '未学习(-1)',
        icon: 'circle',
        color: '#9EB0C8',
        textStyle: {
          color: '#9EB0C8',
        },
      }, {
        name: '掌握熟练(80~100%)',
        icon: 'circle',
        color: '#39D6E1',
        textStyle: {
          color: '#39D6E1',
        },
      }, {
        name: '掌握较好(60~79%)',
        icon: 'circle',
        color: '#12ADFF',
        textStyle: {
          color: '#12ADFF',
        },
      }, {
        name: '掌握一般(40~59%)',
        icon: 'circle',
        color: '#FFE356',
        textStyle: {
          color: '#FFE356',
        },
      }, {
        name: '掌握较弱(20~39%)',
        icon: 'circle',
        color: '#FE9B64',
        itemWidth: 50,
        itemHeight: 50,
        textStyle: {
          color: '#FE9B64',
        },
      }, {
        name: '未掌握(0~19%)',
        icon: 'circle',
        color: '#D157F3',
        textStyle: {
          color: '#D157F3',
        },
      }],
    };
  },
  watch: {
    edges() {
      this.init();
      this.setListener();
    },
  },
  mounted() {
    this.chart = this.$echarts.init(this.$refs.chart);
  },
  methods: {
    // echarts 初始化
    init() {
      this.chart.setOption({
        color: this.legend.map((item) => item.color),
        // legend: {
        //   data: this.legend,
        // },
        legendHoverLink: true,
        series: [{
          data: this.data,
          focusNodeAdjacency: true,
          // focus: 'adjacency',
          symbolSize: 30,
          edgeSymbol: ['circle', 'arrow'],
          edgeSymbolSize: [1, 12],
          force: {
            edgeLength: 230,
            repulsion: 800,
          },
          lineStyle: {
            color: 'source',
            curveness: 0.5,
          },
          type: 'graph',
          layout: 'force',
          animation: true,
          draggable: true,
          categories: this.legend,
          edges: this.edges,
          label: {
            show: true,
            color: 'inherit',
            position: 'top',
            distance: 5,
          },
        }],
      });
      setTimeout(() => {
        const { width, height } = this.$refs.container.getBoundingClientRect();
        const { width: iWidth, height: iHeight } = this.$refs.chart.getBoundingClientRect();
        this.$refs.container.scrollLeft = (iWidth - width) / 2;
        this.$refs.container.scrollTop = (iHeight - height) / 2;
      }, 30);
    },
    setListener() {
      this.chart.on('click', this.showLo);
    },
    // 展现知识点详情
    showLo(node) {
      if (node.dataType !== 'node') {
        return;
      }
      this.visibleLo = true;
      this.currentCode = node.data.knowledge_code;
    },
    setHighlight(index = 0) {
      this.chart.dispatchAction({
        type: 'highlight',
        seriesIndex: 0,
        dataIndex: index,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.c-chart {
  margin-top: 25px;
  position: relative;
  top: -80px;
  .chart-dom-container {
    width: 1288px;
    height: 1004px;
    background: rgba(149, 227, 255, 0.12);
    box-shadow: 0px 8px 8px 0px rgba(0, 61, 163, 0.22),
    0px -8px 8px 0px rgba(0, 61, 163, 0.27), 8px 0px 8px 0px
    rgba(0, 61, 163, 0.22), -8px 0px 8px 0px rgba(0, 61, 163, 0.27);
    border-radius: 8px;
    border: 3px solid #003DA3;
  }
  .chart-dom {
    width: 1288px;
    height: 1004px;
  }
}
</style>
